<script>
    import Modal from './SemanticModal.svelte'

    export let what       = null
    export let activities = []
    export let cancel     = () => {}
    export let confirm    = () => {}   
</script>

<Modal active={activities.length > 0}>
    <div class="ui tiny modal visible active">
        <div class="content">
            <div class="ui icon purple message">
                <i class="bug icon"></i>
                <div class="content">
                    <div class="header">
                        <h2 class="ui header">
                            Atenção
                        </h2>
                    </div>
                </div>
            </div>
            {#if what}
                <h4 class="ui header">
                    A remoção deste {what} causará uma inconsistência no seu inventário
                </h4>
            {/if}
            <slot></slot>
            As atividades abaixo serão afetadas:
            <div>
                {#each activities as activity}
                    <div class="affected">
                        <div class="ui label">{activity.purpose}</div>
                    </div>            
                {/each}            
            </div>
        </div>
        <div class="actions">
            <button class="ui black button" on:click={cancel}  >Cancelar</button>
            <!-- <button class="ui       button" on:click={confirm} >Confirmar</button> -->
        </div>        
    </div>
</Modal>

<style>
    .affected:first-child {
        padding-top: 2em;
    }
    .affected {
        padding: .5em 0;
    }
</style>